function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "programok",
  transform: "translate(11.257 13.273)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11788",
  "data-name": "Path 11788",
  d: "M25.686,12.221l-2.379-1.557.916-1.679a2.925,2.925,0,0,0,.338-1.36V4.963A3.843,3.843,0,0,0,18.1,2.136l.8.868a2.662,2.662,0,0,1,4.469,1.96V7.626a1.731,1.731,0,0,1-.193.793l-1.439,2.638,3.293,2.154a1.559,1.559,0,0,1,.705,1.31V16.5H23.082v1.183h3.846V14.521a2.738,2.738,0,0,0-1.24-2.3Z",
  transform: "translate(-8.051)",
  fill: "#ac1ede",
  stroke: "#ac1ede",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11789",
  "data-name": "Path 11789",
  d: "M12.311,14.474,9.932,12.918l.916-1.679a2.925,2.925,0,0,0,.338-1.36V7.216a3.845,3.845,0,1,0-7.691,0V9.879a2.884,2.884,0,0,0,.333,1.36l.921,1.689L2.384,14.474a2.737,2.737,0,0,0-1.24,2.3l-.018,3.165H13.552V16.774a2.738,2.738,0,0,0-1.24-2.3Zm.057,4.278H2.315l.012-1.978a1.559,1.559,0,0,1,.705-1.31L6.31,13.318,4.866,10.671a1.732,1.732,0,0,1-.188-.793V7.216a2.662,2.662,0,1,1,5.325,0V9.878a1.731,1.731,0,0,1-.193.793L8.371,13.309l3.293,2.154a1.559,1.559,0,0,1,.705,1.31Z",
  transform: "translate(0 -1.069)",
  fill: "#ac1ede",
  stroke: "#ac1ede",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "programok-2",
  "data-name": "programok",
  d: "M36.521,41.722H5.229a5.028,5.028,0,0,1-3.688-1.528A5.015,5.015,0,0,1,.015,36.506V5.216A5.028,5.028,0,0,1,1.543,1.528,5.019,5.019,0,0,1,5.231,0H36.522A5.028,5.028,0,0,1,40.21,1.528a5.019,5.019,0,0,1,1.528,3.688V36.507a5.216,5.216,0,0,1-5.216,5.216ZM18.248,2.608a2.493,2.493,0,0,0-1.833.754,2.5,2.5,0,0,0-.754,1.833,2.559,2.559,0,0,0,.754,1.854,2.608,2.608,0,0,0,3.708,0,2.554,2.554,0,0,0,.754-1.854A2.464,2.464,0,0,0,20.1,3.362a2.572,2.572,0,0,0-1.854-.754Zm7.822,0a2.493,2.493,0,0,0-1.833.754,2.5,2.5,0,0,0-.754,1.833,2.559,2.559,0,0,0,.754,1.854,2.46,2.46,0,0,0,1.833.774,2.54,2.54,0,0,0,1.854-.774A2.515,2.515,0,0,0,28.7,5.195a2.47,2.47,0,0,0-.774-1.833A2.57,2.57,0,0,0,26.07,2.608Zm7.843,0a2.575,2.575,0,0,0-2.608,2.587,2.565,2.565,0,0,0,.754,1.854,2.608,2.608,0,0,0,3.708,0,2.56,2.56,0,0,0,.754-1.854,2.49,2.49,0,0,0-.754-1.833A2.532,2.532,0,0,0,33.913,2.608Zm2.608,10.43a2.487,2.487,0,0,0-.774-1.854,2.538,2.538,0,0,0-1.833-.754H7.838a2.575,2.575,0,0,0-2.608,2.608V33.9a2.575,2.575,0,0,0,2.608,2.608H33.914a2.538,2.538,0,0,0,1.833-.754,2.487,2.487,0,0,0,.774-1.854V13.038Z",
  transform: "translate(-10.771 -12.773)",
  fill: "#ac1ede",
  stroke: "#fff",
  strokeWidth: 1
}));

var SvgProgramok = function SvgProgramok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.723,
    height: 42.723,
    viewBox: "0 0 42.723 42.723",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgramok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/programok.4c5195f4.svg";
export { ForwardRef as ReactComponent };